import {
    DELIVERIES_CONNECT,
    DELIVERIES_DISCONNECT,
    DELIV_DONE,
    DELIVERIES_ERROR,
    DELIVERIES_UPDATE,
    DELIV_START,
    DELIV_START_UPD
} from "../../constants/action-types";

import initialState from "../initialState";

const deliveries = (state = initialState.deliveries, action) => {
    switch (action.type) {        
        case DELIVERIES_CONNECT:
            if (state.delivState === 1) {return state;}
            return { ...state, delivState: 1 }

        case DELIVERIES_DISCONNECT:
            if (state.delivState === 4) {return state;}
            return { ...state, delivState: 4 }

        case DELIV_DONE:
            return { ...state, delivState:0 }

        case DELIVERIES_ERROR:
            if (state.delivState === 3) {return state;}
            return { ...state, delivState: 3 }

        case DELIVERIES_UPDATE:
            return {
                ...state,
                delivState:0,
                deliveries: action.payload.map(i=>i)
            }
        
        case DELIV_START:
            if (state.delivState === 5) {return state;}
            return { 
                ...state, 
                delivState: 5,
                key: action.payload }

        case DELIV_START_UPD:
            if (state.delivState === 6) {return state;}
            return { 
                ...state, 
                delivState: 6,
                key: action.payload.key,
                startDate: action.payload.date}

        default:
            return state;
    }
}

export default deliveries;


// WEBPACK FOOTER //
// ./src/store/reducers/deliveries.js